var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCameraRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.174,
    height: 29.454,
    viewBox: "0 0 36.174 29.454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M23.921,20.528a5.833,5.833,0,1,1-5.834-5.834A5.84,5.84,0,0,1,23.921,20.528Zm12.253-8.284v16.57a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V12.244a4,4,0,0,1,4-4H8.92V6.86a3.5,3.5,0,0,1,3.5-3.5H23.754a3.5,3.5,0,0,1,3.5,3.5V8.243h4.92A4,4,0,0,1,36.174,12.244Zm-9.253,8.284a8.833,8.833,0,1,0-8.834,8.834A8.844,8.844,0,0,0,26.921,20.528Z",
    transform: "translate(0 -3.36)",
    fill: "#9f393a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraRed);
export default __webpack_public_path__ + "static/media/icon-camera-red.6b8c0692f5a3b9b807903cddf5f318e8.svg";
export { ForwardRef as ReactComponent };